import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=7c853854&scoped=true"
import script from "./BottomButton.vue?vue&type=script&lang=js"
export * from "./BottomButton.vue?vue&type=script&lang=js"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=7c853854&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c853854",
  null
  
)

export default component.exports